import {
  Logger,
  consoleReporter,
} from '@service-initiation/shared-clients-logger';
import { ospReporter } from '@service-initiation/shared-clients-osp-reporter';
import { withRedactedPaths } from '@service-initiation/shared-utils-redact';

import { withTimezoneContext, withUserBrowserContext } from './transformations';

export const logger = new Logger({
  reporters:
    process.env['NX_PUBLIC_APP_ENV'] === 'production'
      ? [ospReporter]
      : [consoleReporter],
  transformations: [
    withUserBrowserContext,
    withTimezoneContext,
    withRedactedPaths({
      censor: '*** REDACTED ***',
      paths: ['*customer.*'],
    }),
  ],
});
